<div class="content-wrapper" style="margin-bottom: 100px">
  <div class="layout-px-spacing">
    <div class="row layout-spacing layout-top-spacing" id="cancel-row">
      <div class="col-lg-12">
        <div class="">
          <div class="widget-content searchable-container grid">
            <div class="card-box">
              <div class="row w-100">
                <div class="col-xl-12 col-lg-12 align-self-center w-100">
                  <a routerLink="../.." class="btn btn-sm btn-primary p-1 px-2"
                    ><i class="las la-arrow-left"></i>
                    {{ 'back' | translate }}</a
                  >
                </div>
                <div
                  class="col-xl-8 col-lg-8 col-md-8 company-detail-container mt-4"
                >
                  <div class="d-flex align-items-start" style="gap: 2rem">
                    <img
                      *ngIf="currentCompany?.logo"
                      class="logo-img"
                      [src]="currentCompany?.logo"
                      alt="avatar"
                    />
                    <div class="company-info">
                      <p class="name mb-1">{{ currentCompany?.name }}</p>
                      <a class="text-primary font-12 mb-2 d-block" href="#">{{
                        currentCompany?.url
                      }}</a>
                      <p>{{ currentCompany?.description }}</p>
                    </div>
                  </div>
                </div>
                <!--
                            <div class="col-xl-4 col-lg-4 col-md-4 company-detail-container mt-5">
                                <div class="company-info-right">
                                    <p>Total Projects : <a>10</a></p>
                                    <p>Team Members : <a>17</a></p>
                                    <p>Status : <a class="badge badge-success text-light">Active</a></p>
                                    <p>Partnered Since : <a>2001</a></p>
                                    <p>No. of Years : <a>19 yrs</a></p>
                                    <div class="d-flex social-media align-items-center justify-content-between">
                                        <p class="mb-0">Connect : </p>
                                        <div>
                                            <a href=""><i class="lab la-facebook-square"></i></a>
                                            <a href=""><i class="lab la-twitter"></i></a>
                                            <a href=""><i class="lab la-linkedin-in"></i></a>
                                            <a href=""><i class="lab la-github"></i></a>
                                            <a href=""><i class="lab la-dribbble"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            -->
              </div>
            </div>
            <!-- Tab Starts -->
            <div class="card-box">
              <div class="w-100 animated-underline-content">
                <ul class="nav nav-tabs mb-3" id="lineTab" role="tablist">
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      id="underline-about-tab"
                      data-toggle="tab"
                      href="#underline-about"
                      role="tab"
                      aria-controls="underline-about"
                      aria-selected="true"
                      >{{ 'tab.info' | translate }}</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="underline-project-tab"
                      data-toggle="tab"
                      href="#underline-project"
                      role="tab"
                      aria-controls="underline-project"
                      aria-selected="false"
                      >{{ 'tab.users' | translate }}</a
                    >
                  </li>
                  <li
                    class="nav-item"
                    *ngIf="
                      isSuperAdmin &&
                      currentCompany?.name === 'Singlar Innovación'
                    "
                  >
                    <a
                      class="nav-link"
                      id="underline-pendientes-tab"
                      data-toggle="tab"
                      href="#underline-pendientes"
                      role="tab"
                      aria-controls="underline-pendientes"
                      aria-selected="false"
                      >{{ 'tab.pending' | translate }}</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="underline-team-tab"
                      data-toggle="tab"
                      href="#underline-team"
                      role="tab"
                      aria-controls="underline-team"
                      aria-selected="false"
                      >{{ 'tab.configuration' | translate }}</a
                    >
                  </li>
                  <li class="nav-item" *ngIf="canEditLicense">
                    <a
                      class="nav-link"
                      id="underline-licencia-tab"
                      data-toggle="tab"
                      href="#underline-licencia"
                      role="tab"
                      aria-controls="underline-team"
                      aria-selected="false"
                      >Licencia</a
                    >
                  </li>
                </ul>
                <div class="tab-content" id="lineTabContent-3">
                  <div
                    class="tab-pane fade show active"
                    id="underline-about"
                    role="tabpanel"
                    aria-labelledby="underline-about-tab"
                  >
                    <div class="d-flex flex-wrap" *ngIf="!isSuperAdmin">
                      <div class="col-xl-4 col-lg-4 col-md-4">
                        <div class="contact-info mb-4">
                          <p>
                            <a href="#"
                              ><i class="las la-globe"></i
                              >{{ currentCompany?.url }}</a
                            >
                          </p>
                          <p>
                            <a href="#"
                              ><i class="lar la-envelope"></i
                              >{{ currentCompany?.email }}</a
                            >
                          </p>
                          <p>
                            <a href="#"
                              ><i class="las la-phone"></i
                              >{{ currentCompany?.phone }}</a
                            >
                          </p>
                        </div>
                      </div>
                      <div class="col-xl-8 col-lg-8 col-md-8">
                        <div class="contact-info mb-4">
                          <p class="strong">
                            {{ 'companies.create.description' | translate }}
                          </p>
                          <p class="font-12">
                            {{ currentCompany?.description }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- Business description if isSuperAdmin -->
                    <div class="mb-4" *ngIf="isSuperAdmin || isCompanyAdmin">
                      <div class="widget-header">
                        <div class="row">
                          <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                            <h4>
                              {{
                                'companies.create.companyDescription'
                                  | translate
                              }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="widget-content widget-content-area">
                        <div class="w-100">
                          <div class="form-group row">
                            <div class="col-lg-6">
                              <label
                                >{{ 'companies.create.fullName' | translate }}
                                <span class="text-danger">*</span></label
                              >
                              <input
                                [(ngModel)]="newCompany.Name"
                                name="name"
                                type="text"
                                class="form-control"
                                [placeholder]="
                                  'companies.create.fullName' | translate
                                "
                              />
                              <span class="form-text text-muted">{{
                                'companies.create.enterFullName' | translate
                              }}</span>
                            </div>

                            <div class="col-lg-6">
                              <label>{{
                                'companies.create.direction' | translate
                              }}</label>
                              <input
                                [(ngModel)]="newCompany.Address"
                                name="address"
                                type="text"
                                maxlength="256"
                                class="form-control"
                                [placeholder]="
                                  'companies.create.direction' | translate
                                "
                              />
                              <span class="form-text text-muted">{{
                                'companies.create.enterLocation' | translate
                              }}</span>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-lg-6">
                              <label>{{
                                'companies.create.webUrl' | translate
                              }}</label>
                              <input
                                [(ngModel)]="newCompany.WebAddress"
                                name="webAddress"
                                type="text"
                                class="form-control"
                                [placeholder]="
                                  'companies.create.webUrl' | translate
                                "
                              />
                              <span class="form-text text-muted">{{
                                'companies.create.enterWebUrl' | translate
                              }}</span>

                              <label style="margin-top: 20px">{{
                                'companies.create.phone' | translate
                              }}</label>
                              <div class="input-group">
                                <input
                                  [(ngModel)]="newCompany.Phone"
                                  name="phone"
                                  type="text"
                                  class="form-control"
                                  [placeholder]="
                                    'companies.create.phone' | translate
                                  "
                                />
                              </div>
                              <span class="form-text text-muted">{{
                                'companies.create.enterPhone' | translate
                              }}</span>
                            </div>
                            <div class="col-lg-6">
                              <div class="form-group mb-1">
                                <label for="exampleTextarea"
                                  >{{
                                    'companies.create.description' | translate
                                  }}
                                </label>
                                <textarea
                                  [(ngModel)]="newCompany.Description"
                                  name="description"
                                  class="form-control"
                                  id="exampleTextarea"
                                  rows="6"
                                ></textarea>
                              </div>
                              <span class="form-text text-muted">{{
                                'companies.create.enterDescription' | translate
                              }}</span>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-lg-6">
                              <label>{{
                                'companies.create.email' | translate
                              }}</label>
                              <div class="input-group">
                                <input
                                  [(ngModel)]="newCompany.Email"
                                  name="email"
                                  type="text"
                                  class="form-control"
                                  [placeholder]="
                                    'companies.create.email' | translate
                                  "
                                />
                              </div>
                              <span class="form-text text-muted">{{
                                'companies.create.enterEmail' | translate
                              }}</span>
                            </div>
                            <div class="col-lg-6">
                              <div id="dropzone">
                                <div
                                  class="d-flex"
                                  style="flex-direction: column"
                                >
                                  <label for="exampleTextarea">{{
                                    'record.filter.department' | translate
                                  }}</label>
                                  <span>{{
                                    'companies.departmentDescription'
                                      | translate
                                  }}</span>
                                  <div class="d-flex">
                                    <span
                                      style="
                                        font-size: 0.7rem;
                                        font-weight: 600;
                                        color: #747474;
                                      "
                                      >{{ 'companies.desc1' | translate }}</span
                                    >
                                    &nbsp;
                                    <a
                                      (click)="downloadExcel()"
                                      style="
                                        font-size: 0.7rem;
                                        font-weight: 600;
                                        color: blue;
                                        cursor: pointer;
                                        text-decoration: underline;
                                      "
                                      >{{ 'companies.desc2' | translate }}</a
                                    >
                                    &nbsp;
                                    <span
                                      style="
                                        font-size: 0.7rem;
                                        font-weight: 600;
                                        color: #747474;
                                      "
                                      >{{ 'companies.desc3' | translate }}</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="dz-message needsclick"
                                  style="margin-top: 1.5rem"
                                >
                                  <input
                                    type="file"
                                    (change)="onCsvSelected($event)"
                                    accept=".csv"
                                    class="dz-message needsclick"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-lg-6">
                              <div class="form-group row">
                                <div class="col-lg-12 col-sm-12">
                                  <div id="dropzone">
                                    <label for="exampleTextarea">Logo</label>
                                    <div class="dz-message needsclick">
                                      <input
                                        type="file"
                                        (change)="onFileSelected($event)"
                                        accept="image/*"
                                        class="dz-message needsclick"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="form-group row">
                                <div class="col-lg-12 col-sm-12">
                                  <div id="dropzone">
                                    <label for="exampleTextarea">Idioma</label>
                                    <ng-select
                                      class="selectpicker"
                                      disableVirtualScroll
                                      [items]="langs"
                                      [bindLabel]="'langCode' | translate"
                                      bindValue="langCode"
                                      [closeOnSelect]="false"
                                      [(ngModel)]="newCompany.Language"
                                    ></ng-select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="widget-footer text-right">
                        <button
                          class="btn btn-sm btn-primary"
                          type="submit"
                          (click)="save()"
                        >
                          {{ 'submit' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Projects -->
                  <div
                    class="tab-pane fade"
                    id="underline-project"
                    role="tabpanel"
                    aria-labelledby="underline-project-tab"
                  >
                    <div
                      class="widget-footer text-right"
                      *ngIf="companyId === 1"
                    >
                      <button
                        class="btn btn-sm btn-primary"
                        type="submit"
                        (click)="createUser()"
                      >
                        {{ 'createuser' | translate }}
                      </button>
                    </div>
                    <div class="row w-100" style="margin-top: 2rem">
                      <div class="col-md-12">
                        <div
                          class="d-flex justify-content-center loader"
                          *ngIf="isLoading"
                        >
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                        <form>
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col">
                                  {{ 'companies.create.fullName' | translate }}
                                </th>
                                <th scope="col">
                                  {{ 'companies.create.email' | translate }}
                                </th>
                                <th scope="col">
                                  {{ 'record.table.department' | translate }}
                                </th>
                                <th scope="col">
                                  {{ 'companies.create.phone' | translate }}
                                </th>
                                <th scope="col">
                                  {{ 'record.table.opt' | translate }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let user of users">
                                <td>
                                  {{
                                    compareUsernameWithMicrosoftGuid(
                                      user.userName
                                    )
                                  }}
                                </td>
                                <td>{{ user.email }}</td>
                                <td>{{ user.department }}</td>
                                <td>{{ user.phone }}</td>
                                <td>
                                  <i
                                    class="icon edit"
                                    (click)="editUser(user)"
                                  ></i
                                  ><i
                                    (click)="deleteUser(user)"
                                    class="lar la-trash-alt text-danger font-20 mr-2"
                                  ></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <div
                            *ngIf="users.length <= 0"
                            class="d-flex justify-content-center"
                          >
                            <span>{{ 'noDataAvailable' | translate }}</span>
                          </div>
                        </form>
                      </div>

                      <div
                        class="d-flex justify-content-center p-2"
                        *ngIf="users.length > 0"
                        style="margin: 0 auto"
                      >
                        <ngb-pagination
                          [collectionSize]="collectionSize"
                          [(page)]="page"
                          [pageSize]="pageSize"
                          [rotate]="true"
                          [maxSize]="5"
                          [ellipses]="false"
                          [boundaryLinks]="true"
                          (pageChange)="refreshUsers()"
                        >
                        </ngb-pagination>
                      </div>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="underline-pendientes"
                    role="tabpanel"
                    aria-labelledby="underline-pendientes-tab"
                  >
                    <div class="row w-100" style="margin-top: 2rem">
                      <div class="col-md-12">
                        <div
                          class="d-flex justify-content-center loader"
                          *ngIf="isLoading2"
                        >
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                        <form>
                          <div class="col-md-12">
                            <div
                              class="d-flex justify-content-center loader"
                              *ngIf="isLoading"
                            >
                              <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                            <form>
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th scope="col">
                                      {{
                                        'companies.create.fullName' | translate
                                      }}
                                    </th>
                                    <th scope="col">
                                      {{ 'companies.create.email' | translate }}
                                    </th>
                                    <th scope="col">
                                      {{
                                        'record.table.department' | translate
                                      }}
                                    </th>
                                    <th scope="col">
                                      {{ 'companies.create.phone' | translate }}
                                    </th>
                                    <th scope="col">
                                      {{ 'record.table.opt' | translate }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let user of pendingUsers">
                                    <td>
                                      {{
                                        compareUsernameWithMicrosoftGuid(
                                          user.userName
                                        )
                                      }}
                                    </td>
                                    <td>{{ user.email }}</td>
                                    <td>{{ user.department }}</td>
                                    <td>{{ user.phone }}</td>
                                    <td>
                                      <i
                                        class="icon edit"
                                        (click)="editPendingUser(user)"
                                      ></i>
                                      <i
                                        (click)="deletePendingUser(user)"
                                        class="lar la-trash-alt text-danger font-20 mr-2"
                                      ></i>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <div
                                *ngIf="pendingUsers.length <= 0"
                                class="d-flex justify-content-center"
                              >
                                <span>{{ 'noDataAvailable' | translate }}</span>
                              </div>
                            </form>
                          </div>

                          <div
                            class="d-flex justify-content-center p-2"
                            *ngIf="pendingUsers.length > 0"
                            style="margin: 0 auto"
                          >
                            <ngb-pagination
                              [collectionSize]="pendingCollectionSize"
                              [(page)]="pendingPage"
                              [pageSize]="pendingPageSize"
                              [rotate]="true"
                              [maxSize]="5"
                              [ellipses]="false"
                              [boundaryLinks]="true"
                              (pageChange)="refreshPendingUsers()"
                            >
                            </ngb-pagination>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <!-- Configuracion -->
                  <div
                    class="tab-pane fade"
                    id="underline-team"
                    role="tabpanel"
                    aria-labelledby="underline-team-tab"
                  >
                    <div class="row w-100 m-0">
                      <div class="col-lg-12 layout-spacing">
                        <div class="mb-4">
                          <div class="widget-content widget-content-area">
                            <div class="w-100">
                              <!-- Conexión Tenant -->
                              <div class="form-group row">
                                <h5>
                                  {{
                                    'companies.create.tenantConection'
                                      | translate
                                  }}
                                </h5>
                              </div>
                              <div class="form-group row">
                                <span>{{
                                  'companies.create.tenantConectionSub'
                                    | translate
                                }}</span>
                              </div>
                              <div class="form-group row">
                                <div class="col-lg-6">
                                  <label>{{
                                    'companies.create.certificateId' | translate
                                  }}</label>
                                  <div class="input-group">
                                    <input
                                      [(ngModel)]="newCompany.Certificate"
                                      name="name"
                                      type="text"
                                      class="form-control"
                                      [placeholder]="
                                        'companies.create.certificateId'
                                          | translate
                                      "
                                    />
                                  </div>
                                  <span class="form-text text-muted">{{
                                    'companies.create.enterCertificateId'
                                      | translate
                                  }}</span>

                                  <label style="margin-top: 20px">{{
                                    'companies.create.webDomain' | translate
                                  }}</label>
                                  <input
                                    [(ngModel)]="newCompany.WebDomain"
                                    name="webDomain"
                                    type="text"
                                    class="form-control"
                                    [placeholder]="
                                      'companies.create.webDomain' | translate
                                    "
                                  />
                                  <span class="form-text text-muted">{{
                                    'companies.create.enterWebDomain'
                                      | translate
                                  }}</span>
                                </div>
                                <div class="col-lg-6">
                                  <label>{{
                                    'companies.create.appId' | translate
                                  }}</label>
                                  <input
                                    [(ngModel)]="newCompany.ApplicationId"
                                    name="applicationId"
                                    type="text"
                                    class="form-control"
                                    [placeholder]="
                                      'companies.create.appId' | translate
                                    "
                                  />
                                  <span class="form-text text-muted">{{
                                    'companies.create.enterAppId' | translate
                                  }}</span>
                                </div>
                                <div class="form-group row"></div>
                                <div class="col-lg-6">
                                  <div id="dropzone">
                                    <label
                                      style="margin-top: 20px"
                                      for="exampleTextarea"
                                      >{{
                                        'companies.create.certificate'
                                          | translate
                                      }}</label
                                    >
                                    <div class="dz-message needsclick">
                                      <input
                                        type="file"
                                        (change)="
                                          onFileSelectedCertificate($event)
                                        "
                                        accept="image/*"
                                        class="dz-message needsclick"
                                      />
                                    </div>
                                  </div>
                                  <label style="margin-top: 20px">{{
                                    'companies.create.dataTypesToImport'
                                      | translate
                                  }}</label>
                                  <div class="input-group">
                                    <ng-select
                                      style="width: 100%"
                                      class="selectpicker"
                                      [compareWith]="compareFn"
                                      bindLabel="label"
                                      bindValue="id"
                                      [items]="dataTypes"
                                      [closeOnSelect]="false"
                                      [(ngModel)]="newCompany.DataTypes"
                                      multiple="true"
                                    ></ng-select>
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                  <label>{{
                                    'companies.create.password' | translate
                                  }}</label>
                                  <div class="input-group">
                                    <input
                                      [(ngModel)]="
                                        newCompany.CertificatePassword
                                      "
                                      name="password"
                                      type="password"
                                      class="form-control"
                                      [placeholder]="
                                        'companies.create.password' | translate
                                      "
                                    />
                                  </div>
                                  <span class="form-text text-muted">{{
                                    'companies.create.enterPassword' | translate
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="widget-footer text-right">
                            <button
                              class="btn btn-sm btn-primary"
                              type="submit"
                              (click)="save()"
                            >
                              {{ 'submit' | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Licencia -->
                  <div
                    class="tab-pane fade"
                    id="underline-licencia"
                    role="tabpanel"
                    aria-labelledby="underline-licencia-tab"
                  >
                    <company-license
                      *ngIf="license"
                      [license]="license"
                    ></company-license>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
